module.exports = __webpack_public_path__ + "img/reimu hakurei_sc1.afe4a750.png";